import type { CSSProperties } from "react";
import type { AuthorColorOf } from "@common/components/remedy/OoxmlContent";
import { PROPOSED_REVISIONS_AUTHOR, PROPOSED_REVISIONS_HIGHLIGHT } from "@common/utils/redline/ooxml/proposed-revisions";

export const INSERTION_UNDERLINE: CSSProperties = { textDecoration: "underline", textDecorationSkipInk: "none" };

export const revisionPaintOf = (author: string, authorColorOf: AuthorColorOf): CSSProperties =>
    author === PROPOSED_REVISIONS_AUTHOR ? { background: PROPOSED_REVISIONS_HIGHLIGHT } : { color: authorColorOf(author) };

const cssPropertyNameOf = (reactPropertyName: string): string =>
    reactPropertyName.replace(/[A-Z]/g, (capitalLetter) => `-${capitalLetter.toLowerCase()}`);

export const cssTextOf = (revisionStyle: CSSProperties): string =>
    Object.entries(revisionStyle).map(([reactPropertyName, cssValue]) => `${cssPropertyNameOf(reactPropertyName)}: ${cssValue};`).join(" ");
